import React from 'react';
import { useDashboard } from '../context/DashboardContext';

function Header({ dark, setDark }) {
  const { userRole, setUserRole } = useDashboard();

  return (
    <header className="header">
      <div className="header-inner">
        <div className="header-brand">
          <div className="brand-logo">F</div>
          <div>
            <h1 className="brand-title">Finance Dashboard</h1>
            <p className="brand-subtitle">Manage your finances with ease</p>
          </div>
        </div>

        <div className="header-actions">
          <div className="role-switcher">
            <button
              className={`role-btn ${userRole === 'admin' ? 'role-btn--active' : ''}`}
              onClick={() => setUserRole('admin')}
            >
              <span className="role-icon">🛡</span>
              <span>Admin</span>
            </button>
            <button
              className={`role-btn ${userRole === 'viewer' ? 'role-btn--active' : ''}`}
              onClick={() => setUserRole('viewer')}
            >
              <span className="role-icon">👤</span>
              <span>Viewer</span>
            </button>
          </div>

          <button
            className="icon-btn"
            onClick={() => setDark((d) => !d)}
            title="Toggle theme"
          >
            {dark ? '☀️' : '🌙'}
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
